'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dEnvelope$002dId$0024 from "./presto.types$-Envelope-Id$.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$34() {
  this.bic = null;
  this.bia = null;
  this.bib = false;
  this.bi8 = null;
  this.bi9 = false;
  this.bid = false;
  this.bie = false;
  this.bic = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_PrestoRouter$$anon$34 as $c_Lpresto_PrestoRouter$$anon$34 };
$p = $c_Lpresto_PrestoRouter$$anon$34.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$34;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$34() {
}
export { $h_Lpresto_PrestoRouter$$anon$34 as $h_Lpresto_PrestoRouter$$anon$34 };
$h_Lpresto_PrestoRouter$$anon$34.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.af = (function() {
  return this.bic;
});
$p.t = (function() {
  if ((!this.bib)) {
    this.bia = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("id", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.bib = true;
  }
  return this.bia;
});
$p.ag = (function() {
  if ((!this.bi9)) {
    this.bi8 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dEnvelope$002dId$0024.$m_Lpresto_types$EnvelopeId$().cJ4(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.bi9 = true;
  }
  return this.bi8;
});
$p.v = (function() {
  if ((!this.bie)) {
    this.bid = false;
    this.bie = true;
  }
  return this.bid;
});
$p.ae = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_PrestoRouter$$anon$34 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$34, "presto.PrestoRouter$$anon$34", ({
  O8: 1,
  a: 1,
  l: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$34 as $d_Lpresto_PrestoRouter$$anon$34 };
//# sourceMappingURL=presto.-Presto-Router$$anon$34.js.map
